import { useEffect, useState } from "react";

function useDebounce(value: string, delay: number): string {
  const [state, setState] = useState<string>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setState(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return state;
}

export { useDebounce };
